import { Redirect, Route } from 'react-router-dom'

import { useUserContext } from '../../../contexts/userContext'
import { saveAuthReturnPath } from '../../../utils/authReturnPath'
import { LoadingIndicator } from '../LoadingIndicator'
import { PermissionWrapper } from '../PermissionWrapper/PermissionWrapper'

export function PermissionRoute({
  permission,
  component: Component,
  ...rest
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper rest type
}: any) {
  const { state: authState } = useUserContext()
  if (authState.loading) return <LoadingIndicator />

  return (
    <Route
      {...rest}
      render={props => {
        if (authState.isAuthenticated) {
          return (
            <PermissionWrapper permission={permission}>
              <Component {...props} {...rest} />
            </PermissionWrapper>
          )
        }

        saveAuthReturnPath(props.location)
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }}
    />
  )
}
